import {
  FormGroup, FormControl, Validators, AbstractControl, FormArray,
} from '@angular/forms';
import { startWith } from 'rxjs';
import { createAddressForm } from '../address-form/address.form';

export const createPartnerForm = () => new FormGroup({
  documentType: new FormControl('DNI', [Validators.required]),
  documentNumber: new FormControl('', [Validators.required, Validators.minLength(8)]),
  isPEP: new FormControl('')
});

export const createPartnerCEDataForm = () => new FormGroup({
  firstName: new FormControl(null, [Validators.required]),
  secondName: new FormControl(null, [Validators.required]),
  lastName: new FormControl(null, [Validators.required]),
  motherLastName: new FormControl(null, [Validators.required]),
  birthCountry: new FormControl(null, [Validators.required]),
  nationality: new FormControl(null, [Validators.required]),
  address: createAddressForm(),
});

export const createPartnersListForm = (forms: FormGroup[]) => {
  const form = new FormArray(forms);
  return form;
};

export const onPartnerFormUserInput = ({
  on,
  when,
  exec,
  undo,
}: {
  on: FormGroup;
  when: (val: any) => any;
  exec?: (control: FormGroup) => void;
  undo?: (control: FormGroup) => void;
}) => {
  const control = on.get('documentType')!;
  return control.valueChanges
    .pipe(startWith(control.value))
    .subscribe(value => (when(value) ? exec?.(on) : undo?.(on)));
};

export const appendPartnerListForm = ({
  to: form,
  with: instance,
}: {
  to: AbstractControl;
  with: AbstractControl;
}) => {
  if (form instanceof FormGroup) {
    form.addControl('partnerList', instance);
  } else if (form instanceof FormArray) {
    form.push(instance);
  }
};

export const removePartnerListForm = ({
  from: form,
  index,
  options,
}: {
  from: AbstractControl;
  index?: number,
  options?: {
    emitEvent: boolean;
    [key: string]: any;
  },
}) => {
  if (form instanceof FormGroup) {
    form.removeControl('partnerList', options);
  } else if (form instanceof FormArray) {
    if (!index) throw new Error('Removed index must be provided for FormArray');
    form.removeAt(index, options);
  }
};

export const appendPartnerCEDataForm = ({
  to: form,
  with: instance,
}: {
  to: AbstractControl;
  with: AbstractControl;
}) => {
  if (form instanceof FormGroup) {
    form.addControl('CEData', instance);
  } else if (form instanceof FormArray) {
    form.push(instance);
  }
};

export const removePartnerCEDataForm = ({
  from: form,
}: {
  from: FormGroup;
}) => {
  form.removeControl('CEData');
};

export const getPartnerListFormInstance = ({
  from: form,
}: {
  from: AbstractControl;
}) => form.get('partnerList') as FormArray;
